import isNumber from './isNumber';

const getMaximumLegend = maximum => {
  if (maximum.legend) {
    return maximum.legend;
  }
  if (isNumber(maximum)) {
    return { label: undefined, value: maximum };
  }
  return maximum;
};

export default getMaximumLegend;
